
import {itemKey} from './boxChampProjection';

export function reopenTarget({view, orderItemId, kitId = null, preferredBoxId = null, sealConfirmedBoxIds = []} = {}) {
  if (!view || !view.projection) return null;
  const confirmed = new Set(sealConfirmedBoxIds || []);

  const key = itemKey(orderItemId, kitId);
  const holders = [];
  view.projection.boxes.forEach(entry => {
    entry.rows.forEach(r => {
      if (itemKey(r.row.order_item_id, r.row.kit_id) === key && r.filled > 0) {
        holders.push(entry);
      }
    });
  });
  if (!holders.length) return null;

  const preferred =
    preferredBoxId == null
      ? null
      : holders.find(entry => entry.box.id === preferredBoxId);
  const target = preferred || holders[holders.length - 1];

  return target.sealed || confirmed.has(target.box.id) ? target.box : null;
}
